import Wrapper from './Wrapper.js'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const ImageDrop = (props) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Wrapper
        images={props.images}
        onFileSelect={props.onFileSelect}
        onImageDelete={props.onImageDelete}
      />
    </DndProvider>
  )
}

export default ImageDrop